import LoginView from '@/views/Auth/LoginView.vue';
import ForgotPasswordView from '@/views/Auth/ForgotPasswordView.vue';
import RecoveryPasswordView from '@/views/Auth/RecoveryPasswordView.vue';
import ManutencaoView from '@/views/SystemViews/ManutencaoView.vue';
import PrivacyView from '@/views/Auth/PrivacyView.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    props: true,
    component: LoginView,
  },
  {
    path: '/esqueci-minha-senha',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
  },
  {
    path: '/recuperar-senha',
    name: 'RecuperarSenha',
    props: true,
    component: RecoveryPasswordView,
  },
  {
    path: '/manutencao',
    name: 'Manutencao',
    component: ManutencaoView,
  },
  {
    path: '/privacidade',
    name: 'Privacidade',
    component: PrivacyView,
  },
  {
    path: '*',
    redirect: {
      name: 'Login',
    },
  },
];

export default routes;
